






































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import {
  PartSale,
  getHeaders,
  IFilter,
  PartSaleCustomerModel,
  IEmailViewModel,
  UberRequesModel,
  PartSaleDetail,
  PaymentModel,
} from '@/models/fixedops/partsales';
import { MetadataType, MetadataKeyIdentifier } from '@/enums/enums';
import { DateTimeHelper } from '@/helper/date-time.helper';
import { IDialogOption } from '@/models/dialog';
import { depositLogService, laneService, partSalesService, paymentService, repairOrderService } from '@/shared';
import { PaymentTypeDialog, RoleType } from '@/helper/enum';
import { Utils } from '@/helper/utils';
import { GetLaneSelectList } from '@/models/admin/lane';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    VoiceConversation: () =>
      import('@/components/partsales/voice.conversation.vue'),
    EmailSendDialog: () => import('@/components/partsales/email.send.vue'),
    CustomerInformation: () =>
      import('@/components/partsales/customer.information.vue'),
    Datepicker: () => import('@/components/common/app.datepicker.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue'),
  },
})
export default class PartSalesListPage extends Base {

  public paymentDialog: boolean = false;
  public showInvoiceDatePicker: boolean = false;
  public pagination = new PaginationModel('invoiceNumber');
  public loading: boolean = false;
  public actions: VAction[] = [];
  public headers: VHeaders[] = getHeaders(this);
  public partSales: PartSale[] = [];
  public partSalesModel: PartSale = new PartSale();
  public customerModel: PartSaleCustomerModel = new PartSaleCustomerModel();
  public customerInfoModel: PartSaleCustomerModel = new PartSaleCustomerModel();
  public uberRequestModel: UberRequesModel = new UberRequesModel();
  public partSaleDetail: PartSaleDetail = new PartSaleDetail();
  public fileOnCardsList: any[] = [];
  public payment: PaymentModel = {};
  public partDetailLoader: boolean = false;
  public lane: string = '';
  public cenposDialog: boolean = false;
  public squareDialog: boolean = false;
  public isCloverDialog: boolean = false;
  public sendMessageDialog: boolean = false;
  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public lanes: any = [];
  public isBypassCreditCardFeeRole: boolean = false;
  public isOverrideCCFeeApplied: boolean = true;
  public isShowWarning: boolean = false;
  public warningMessage = '';
  public filter: IFilter = {
    invoiceNumber: '',
    sortName: '',
    counterPersonId: '',
    transDate: '',
    isOpenPartSaleOrder: true,
  };

  public constants: any = {
    laneId: 0,
    cardId: '',
  };

  public cardPartDetail: any = {
    provider: '',
    email: '',
    zip: '',
    tenantId: 0,
    enterpriseId: 0,
    storeId: 0,
    storeName: '',
    loggedInUserEmail: '',
    loggedInUserId: '',
    customerKey: '',
    amountPaid: '',
    isSquareConfigured: false,
    isCenposConfigured: false,
    isCloverConfigured: false,
    displayDueAmount: '',
    isSendPaymentReceipt: true
  };
  public bypassReason: string = "";
  public isShowBypassReasonField: boolean = false;
  public showSendEmailPopup: boolean = false;
  public showCallPopup: boolean = false;
  public showCustomerInfoPopup: boolean = false;
  public emailModel: IEmailViewModel = {};
  public invoiceNumber: string = '';
  public paymentProvider: string = '';
  public isTerminalPaymentEnabled: boolean = false;

  public uberApproveDialog: boolean = false;
  public shipAddressLoading: boolean = false;
  public estimatedAmount: number = 0;
  public isSubmitOrder: boolean = false;
  public amountToBePaid: string = '0.00';
  public isSendPaymentReceipt: boolean = true;


  public syncDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('partSales.syncDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'primary',
      icon: 'fas fa-sync-alt',
      text: this.$parent.$t('partSales.syncDialog.btnSubmit') as string,
    },
    onAction: (): void => {
      this.syncPartSalesByInvoiceNumber(false);
    },
  };

  public processCardSyncDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('partSales.syncDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'primary',
      icon: 'fa fa-credit-card',
      text: 'Submit',
    },
    onAction: (): void => {
      this.syncPartSalesByInvoiceNumber(true);
    },
  };

  public paymentAmountDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'partSalesDetails.paymentAmountDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'partSalesDetails.paymentAmountDialog.btnPay'
      ) as string,
    },
    onAction: (): void => {
      this.confirmPaymentDialog();
    },
  };

  public creditCardPaymentAmountDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'partSalesDetails.paymentAmountDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'partSalesDetails.paymentAmountDialog.btnPay'
      ) as string,
    },
    onAction: (): void => {
      this.confirmCreditPaymentDialog();
    },
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }

  public callMethod(methodName): void {
    if (methodName === 'search') {
      this.search();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
    if (methodName === 'openSyncDialog') {
      this.openSyncDialog();
    }
    if (methodName === 'openCardSyncDialog') {
      this.openCardSyncDialog();
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: this.$t('partSales.btnManualSync'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('partSales.btnManualSync'),
      click: 'openSyncDialog',
      icon: 'fas fa-sync-alt',
      requestProgress: true,
    });
    buttons.push({
      id: '2',
      type: 'button',
      title: 'Process Credit Card',
      disabled: false,
      visible: true,
      class: 'btn',
      label: 'Process Credit Card',
      click: 'openCardSyncDialog',
      icon: 'fa fa-credit-card',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }

  public async mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'partSales');

    // toolbar
    this.updateToolBar();

    this.$watch(
      () => this.cardPartDetail.paymentType,
      (newVal) => {
        this.creditCardPaymentAmountDialog.action.disable = !newVal;
      },
      { immediate: true }
    );

    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    var role = [RoleType.BypassCreditCardFee.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.isBypassCreditCardFeeRole = isRoleAllowed.includes(role[0]);

    const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (pagination) {
      this.filter.isOpenPartSaleOrder = Boolean(
        JSON.parse(this.$route.query['filters'].toString())
      );
      this.pagination = pagination;
    }
    await this.getDefaultPaymentType();

    this.getPartSales();
    this.setActions();

    this.currentUrl = window.location.href;
    this.$watch(
      "cardPartDetail",
      (newVal) => {
        this.paymentOptions.customerKey = newVal.customerKey;
        this.paymentOptions.customerEmail = newVal.customerEmail;
        this.paymentOptions.merchantEmail = newVal.email2;
        this.paymentOptions.recordKey = newVal.invoiceNumber;
        this.paymentOptions.zipcode = newVal.zipCode;
      },
      {
        deep: true, // Enables deep watching
      }
    );

    this.$watch('cardPartDetail.amountPaid', (newVal) => {
      this.paymentOptions.amount = Number(newVal);
      this.paymentOptions.totalAmount = newVal;
    });
    this.$watch('isSendPaymentReceipt', (newVal) => {
      this.paymentOptions.isSendPaymentReceipt = newVal;
    });

    this.$watch('isOverrideCCFeeApplied', (newVal) => {
      this.paymentOptions.isOverrideCCFeeApplied = newVal;
    });

    this.$watch('bypassReason', (newVal) => {
      this.paymentOptions.bypassReason = newVal;
    });

  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const result = await depositLogService.getDefaultPaymentProvider(
        this.userSession.storeId
      );
      this.paymentProvider = result.paymentProvider;
      this.isTerminalPaymentEnabled = result.isTerminalPaymentEnabled;
    } finally {
      // finally block
    }
  }

  public selectCardPopup: IDialogOption = {
    width: 400,
    title: 'Select Card',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: 'Pay',
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.makeFileOnCardsPayment();
    },
  };

  public selectLanePopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t('partSalesDetails.selectLaneDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t(
        'partSalesDetails.selectLaneDialog.btnPay'
      ) as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.makeVantivPayment();
    },
  };

  public payWithVantivTerminal(): void {
    if (
      Number(this.amountToBePaid) === 0 ||
      isNaN(Number(this.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('partSalesDetails.alertDueAmountIsZero'));
      return;
    }
    this.findLanes(true);
  }

  public async findLanes(openLanePopUp: boolean = false): Promise<void> {
    try {
      if (openLanePopUp) {
        this.selectLanePopup.model = true;
        this.selectLanePopup.loading = true;
        if (this.lanes.length === 0) {
          await this.getLanes();
        }
      }
    } finally {
      this.selectLanePopup.loading = false;
    }
  }

  // GET LANES
  public async getLanes(): Promise<void> {
    const response = await laneService.getLanesAsync();
    this.lane = '';
    this.lanes = response.results;
  }

  public setActions(): void {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-dollar-sign',
        title: 'Pay with Card on file',
        color: 'green',
        visible: (model: any) => {
          if (model.isCardExists) {
            return true;
          }
          return false;
        },
        action: (model: any) => {
          this.getPartSalesDetail(model.invoiceNumber);
        },
      },
      {
        type: 'link',
        icon: 'fas fa-ticket-alt',
        title: 'Receipts',
        visible: (model: any) => {
          if (this.paymentProvider == 'Square' || this.paymentProvider == 'Clover') {
            return true;
          }
          return false;
        },
        action: (model: PartSale) => {
          if (model.invoiceNumber) {
            return {
              name: 'app.partsales.attachment.receipt',
              params: {
                invoiceNumber: model.invoiceNumber,
              },
            };
          }
        },
      },
      {
        type: 'link',
        icon: 'fa fa-eye',
        title: this.$parent.$t(
          'partSales.partSalesGrid.gridActions.view'
        ) as string,
        action: (model: PartSale) => {
          if (model.invoiceNumber) {
            return {
              name: 'app.partsales.detail',
              params: {
                invoiceNumber: model.invoiceNumber,
              },
            };
          }
        },
      },
      {
        type: 'button',
        icon: 'fa fa-envelope',
        title: this.$parent.$t(
          'partSales.partSalesGrid.gridActions.sendEmail'
        ) as string,
        action: (model: PartSale) => {
          this.emailModel = {
            invoiceNumber: model.invoiceNumber,
          };
          this.showSendEmailPopup = true;
        },
      },
      {
        type: 'button',
        icon: 'fa fa-user',
        title: this.$parent.$t(
          'partSales.partSalesGrid.gridActions.customerInformation'
        ) as string,
        action: (model: PartSale) => {
          const customerModel = new PartSaleCustomerModel();
          customerModel.customerKey = model.partsSalesJson.customerKey;
          this.customerInfoModel = customerModel;
          this.showCustomerInfoPopup = true;
        },
      },
      {
        type: 'link',
        icon: 'fa fa-paperclip',
        title: this.$parent.$t(
          'partSales.partSalesGrid.gridActions.viewAttachments'
        ) as string,
        action: (model: PartSale) => {
          if (model.invoiceNumber) {
            return {
              name: 'app.partsales.attachment',
              params: {
                invoiceNumber: model.invoiceNumber,
              },
            };
          }
        },
      },
      {
        type: 'link',
        icon: 'fas fa-comment',
        title: this.$parent.$t(
          'partSales.partSalesGrid.gridActions.sendMessage'
        ) as string,
        visible: (model: PartSale) => {
          return (
            model.partsSalesJson.customerKey !== '0' &&
            model.partsSalesJson.customerKey &&
            this.isFeatureToAccess('MESSAGING')
          );
        },
        action: (model: PartSale) => {
          return {
            name: 'advisor.conversation.add',
            params: {
              type: MetadataType[MetadataType.PartSales],
            },
            query: {
              partSales: '',
              customerKey: model.partsSalesJson.customerKey,
              recordKey: model.invoiceNumber,
            },
          };
        },
      },
      {
        type: 'button',
        icon: 'fa fa-phone',
        title: this.$parent.$t(
          'partSales.partSalesGrid.gridActions.callCustomer'
        ) as string,
        visible: (model: PartSale) => {
          return (
            model.partsSalesJson.customerKey !== '0' &&
            model.partsSalesJson.customerKey &&
            this.isFeatureToAccess('MESSAGING')
          );
        },
        action: (model: PartSale) => {
          if (model.partsSalesJson && model.partsSalesJson.customerKey) {
            const customerModel = new PartSaleCustomerModel();
            customerModel.customerKey = model.partsSalesJson.customerKey;
            customerModel.invoiceNumber = model.invoiceNumber;
            this.customerModel = customerModel;
            this.showCallPopup = true;
          }
        },
      },
      {
        type: 'button',
        icon: 'fab fa-uber',
        title: 'Ship via uber',
        visible: (model: any) => {
          return this.isFeatureToAccess('PART-SALES-SHIPMENT');
        },
        action: (model: PartSale) => {
          if (model.invoiceNumber) {
            this.getShipToAddress(model);
          }
        },
      },
      {
        type: 'link',
        icon: 'fa fa-truck',
        title: 'Ship via uber history',
        visible: (model: any) => {
          return this.isFeatureToAccess('PART-SALES-SHIPMENT');
        },
        action: (model: PartSale) => {
          return {
            name: 'app.partsales.shipmenthistory',
            params: {
              invoiceNumber: model.invoiceNumber,
            },
          };
        },
      },
    ];
  }

  public openSyncDialog() {
    this.invoiceNumber = '';
    this.syncDialog.model = true;
  }

  public openCardSyncDialog() {
    this.invoiceNumber = '';
    this.processCardSyncDialog.model = true;
  }

  public async syncPartSalesByInvoiceNumber(
    isProcessCreditCard
  ): Promise<void> {
    if (!this.invoiceNumber) {
      this.showAlert(false, this.$t('partSales.alertInvoiceNumberRequired'));
      return;
    }
    try {
      this.syncDialog.loading = true;
      this.processCardSyncDialog.loading = true;
      this.$emit('update:progress', this.syncDialog.loading);
      const partSale = await partSalesService.syncPartSalesByInvoiceNumber(
        this.invoiceNumber,
        isProcessCreditCard
      );

      if (isProcessCreditCard) {
        if (partSale.status) {
          this.creditCardPaymentAmountDialog.model = true;
          this.cardPartDetail = partSale;
          this.cardPartDetail.amountPaid = partSale.totalAmount
            ? partSale.totalAmount
            : '0';
          this.payment.amountPaid = partSale.totalAmount
            ? partSale.totalAmount
            : '0';
          this.cardPartDetail.invoiceNumber = this.invoiceNumber;
        } else {
          this.showAlert(false, 'Parts Sale Detail Not Found');
        }
      } else {
        this.showAlert(true, this.$t('partSales.alertPartSaleSynced'));
      }
    } finally {
      this.syncDialog.loading = false;
      this.syncDialog.model = false;
      this.processCardSyncDialog.loading = false;
      this.processCardSyncDialog.model = false;

      this.$emit('update:progress', this.syncDialog.loading);
    }
  }

  public fixDecimalValue(value) {
    if (this.payment.amountPaid) {
      const amount = Number(this.payment.amountPaid);
      const val = amount.toFixed(2);
      this.payment.amountPaid = val;
    } else {
      this.payment.amountPaid = undefined;
    }
  }

  // FILE ON CARD
  public async makeFileOnCardsPayment(): Promise<void> {
    const amount = this.partSaleDetail.displayDueAmount;
    try {
      if (Number(this.amountToBePaid) < 0) {
        this.showAlert(false, 'Amount Should be greater than 0');
        return;
      }

      if (
        Number(this.amountToBePaid) === 0 ||
        isNaN(Number(this.amountToBePaid))
      ) {
        this.showAlert(false, this.$t('partSalesDetails.alertDueAmountIsZero'));
        return;
      }
      if (!this.constants.cardId) {
        this.showAlert(false, 'Please select Card');
        this.selectCardPopup.action.disable = false;
        this.selectCardPopup.loading = false;
        return;
      }
      this.selectCardPopup.action.disable = true;
      this.selectCardPopup.loading = true;
      this.partSaleDetail.displayDueAmount = this.amountToBePaid;
      const totalAmount = this.sumTotalAmount();
      this.partSaleDetail.recordIdentifier = 'PartSales';
      this.partSaleDetail.isSendPaymentReceipt = this.isSendPaymentReceipt;
      const response = await partSalesService.makeFileOnCardsPayment(
        this.partSaleDetail,
        this.constants.cardId,
        totalAmount,
        this.isOverrideCCFeeApplied,
        this.bypassReason
      );

      this.partSaleDetail.displayDueAmount = amount;
      // this.showAlert(true, response.responseMessage);
      if (response.isSuccess) {
        this.showAlert(true, response.responseMessage);
        if (response.recieptUrl != null) {
          window.open(response.recieptUrl, '_blank');
        }
      } else this.showAlert(false, 'fail to make payment');
    } catch {
      this.partSaleDetail.displayDueAmount = amount;
    } finally {
      this.selectCardPopup.action.disable = false;
      this.selectCardPopup.model = false;
      this.selectCardPopup.loading = false;
      this.bypassReason = "";
    }
  }

  public showBypassReasonField(value: boolean) {
    if (!value) {
      this.isShowBypassReasonField = true;
    } else {
      this.isShowBypassReasonField = false;
    }
  }

  public confirmPaymentDialog() {
    let amount = '0.00';

    if (this.validateForm()) {

      // get amountToBePaid
      if (this.payment.paymentMode === 'full') {
        amount = this.partSaleDetail.displayDueAmount;
      } else if (this.payment.paymentMode === 'partial') {
        amount = this.payment.amountPaid;
      } else {
        this.showAlert(
          false,
          this.$t('partSalesDetails.alertPleaseSelectOnePaymentType')
        );
        return;
      }

      if (Number(amount) < 0) {
        this.showAlert(false, 'Amount Should be greater than 0');
        return;
      }

      if (!amount && Number(amount) <= 0) {
        this.showAlert(
          false,
          this.$t('partSalesDetails.alertAmountShouldGreaterThanZeroAndValid')
        );
        return;
      }

      if (Number(amount) > Number(this.partSaleDetail.displayDueAmount)) {
        this.showAlert(
          false,
          this.$t('partSalesDetails.alertAmountShouldLessThanTotalDue')
        );
        return;
      }

      if (this.isShowBypassReasonField && this.bypassReason == "") {
        return;
      }

      this.paymentAmountDialog.model = false;
      this.amountToBePaid = amount;
      this.payWithCardOnFile();
      this.payment.paymentMode = '';
    }
  }

  public allowOnlyNumbers(event: KeyboardEvent): void {
    const key = event.key;
    const input = event.target as HTMLInputElement;

    // allow control keys
    if (
      key === 'Backspace' ||
      key === 'Delete' ||
      key === 'ArrowLeft' ||
      key === 'ArrowRight' ||
      key === 'Tab'
    ) {
      return;
    }

    // allow digits
    if (/^\d$/.test(key)) {
      return;
    }

    // allow ONE decimal point
    if (key === '.' && !input.value.includes('.')) {
      return;
    }

    // block everything else
    event.preventDefault();
  }

  public confirmCreditPaymentDialog() {
    if (this.validateForm()) {
      if (
        Number(this.cardPartDetail.displayDueAmount) !== 0 &&
        Number(this.cardPartDetail.displayDueAmount) !== 0.0 &&
        Number(this.cardPartDetail.displayDueAmount) !== NaN
      ) {
        let amount = '0.00';
        amount = this.cardPartDetail.amountPaid;
        this.paymentOptions.amount = Number(amount);
        this.paymentOptions.totalAmount = amount;
        if (Number(amount) < 0) {
          this.showAlert(false, 'Amount Should be greater than 0');
          return;
        }

        if (!amount && Number(amount) <= 0) {
          this.showAlert(
            false,
            this.$t('partSalesDetails.alertAmountShouldGreaterThanZeroAndValid')
          );
          return;
        }

        if (this.isShowBypassReasonField && this.bypassReason == "") {
          return;
        }

        try {

          this.paymentAmountDialog.model = false;
          this.amountToBePaid = amount;
          // show modal popup
          switch (this.cardPartDetail.paymentType) {
            case 'rdTerminal':
              this.payWithVantivTerminal();
              break;
            case 'rdManual':
              if (this.cardPartDetail.provider == 'Vantiv') {
                this.manualPaymentPopup.model = true;
              } else {
                this.paymentDialog = true;
              }
              break;
            default:
              break;
          }
        } finally {
          this.bypassReason = "";
        }
      } else {
        this.payment.paymentMode = '';
        this.showAlert(
          false,
          'Due Amount is zero.'
        );
        return;

      }
    } else {
      this.payment.paymentMode = '';
      this.showAlert(
        false,
        'Payment is already approved, Transaction amount to pay is equal or less than zero.'
      );
      return;
    }
  }

  public manualPaymentPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'partSalesDetails.manualPaymentDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'partSalesDetails.manualPaymentDialog.agree'
      ) as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.payManually();
    },
    onClose: (): void => {
      this.manualPaymentPopup.action.disable = false;
      this.manualPaymentPopup.loading = false;
      this.manualPaymentPopup.model = false;
    },
  };

  public async payManually(): Promise<void> {
    if (Number(this.cardPartDetail.amountPaid) < 0) {
      this.showAlert(false, 'Amount Should be greater than 0');
      return;
    }

    if (
      Number(this.cardPartDetail.amountPaid) === 0 ||
      isNaN(Number(this.cardPartDetail.amountPaid))
    ) {
      this.showAlert(false, this.$t('partSalesDetails.alertTotalAmountIsZero'));
      return;
    }

    // copy amountToBePaid to displayDue
    const amount = this.cardPartDetail.amountPaid;
    try {
      this.manualPaymentPopup.action.disable = true;
      this.manualPaymentPopup.loading = true;
      const response = await partSalesService.payCardManually(
        this.cardPartDetail,
        amount
      );
      location.href = response.redirectUri;
    } catch (e) {
    } finally {
      this.manualPaymentPopup.action.disable = false;
      this.manualPaymentPopup.loading = false;
      this.manualPaymentPopup.model = false;
      this.cardPartDetail.amountPaid = '';
      this.creditCardPaymentAmountDialog.model = false;
      this.creditCardPaymentAmountDialog.loading = false;
    }
  }

  // VANTIV TERMINAL PAYMENT
  public async makeVantivPayment(): Promise<void> {
    const amount = this.cardPartDetail.amountPaid;
    try {
      if (Number(amount) < 0) {
        this.showAlert(false, 'Amount Should be greater than 0');
        return;
      }

      if (Number(amount) === 0 || isNaN(Number(amount))) {
        this.showAlert(false, this.$t('partSalesDetails.alertDueAmountIsZero'));
        return;
      }
      if (!this.lane) {
        this.showAlert(
          false,
          this.$t('partSalesDetails.alertPleaseSelectLane')
        );
        return;
      }
      this.selectLanePopup.action.disable = true;
      this.selectLanePopup.loading = true;
      this.cardPartDetail.isSendPaymentReceipt = this.isSendPaymentReceipt;
      const response = await partSalesService.makeCardVantivPayment(
        this.cardPartDetail,
        this.lane,
        amount,
        false,
        this.isOverrideCCFeeApplied,
        this.bypassReason
      );
      // this.showAlert(true, response.responseMessage);
      var isApproved = false;
      var isInProcess = false;
      var isFailed = false;
      //For Payroc payments, the payment status is updated via a web job, so there's no need to check the payment status repeatedly
      if (this.paymentProvider != 'Payroc') {
        for (var i = 0; i <= 3; i++) {
          await new Promise((resolve) => setTimeout(resolve, 15000)); // 3 sec
          const paymentResponse = await paymentService.getPaymentDetailStatus(
            response.transactionHeaderId,
            response.transactionDetailId
          );

          if (paymentResponse.status == 'Approved') {
            isApproved = true;
            break;
          }
        }
      } else {
        const paymentResponse = await paymentService.getPaymentDetailStatus(
          response.transactionHeaderId,
          response.transactionDetailId
        );
        if (paymentResponse.status == 'InProcess') {
          isInProcess = true;
        }
        else if (paymentResponse.status == 'Failed') {
          isFailed = true;
        }
      }
      this.isShowWarning = true;

      if (isFailed) {
        this.selectLanePopup.model = false;
        this.showAlert(false, "Payment Failed. Please Try Again");
      }
      else if (isInProcess) {
        this.warningMessage = "Payment Created Successfully, Please check the payment final status in Payment report.";
      }
      else if (isApproved) {
        this.warningMessage = "Payment is Approved Successfully.";
        this.showAlert(true, "Payment is Approved Successfully.");
      }
      else {
        this.warningMessage = "Approving Payment callback taking a longer time, Please check the final status in Payment report.";
      }
      this.selectLanePopup.action.disable = true;
      this.selectLanePopup.loading = false;

    } catch {
    } finally {
      this.selectLanePopup.loading = false;
      this.creditCardPaymentAmountDialog.model = false;
      this.creditCardPaymentAmountDialog.loading = false;
      this.bypassReason = "";
    }
  }

  public payWithCardOnFile(): void {
    if (
      Number(this.amountToBePaid) === 0 ||
      isNaN(Number(this.amountToBePaid))
    ) {
      this.showAlert(false, this.$t('partSalesDetails.alertDueAmountIsZero'));
      return;
    }
    this.selectCardPopup.model = true;
  }

  public validateCenpos(): string {
    let message = '';
    if (
      this.cardPartDetail.city == undefined ||
      this.cardPartDetail.city == ''
    ) {
      message += ' City';
    }

    if (this.cardPartDetail.customerKey == '') {
      message += ' CustomerKey';
    }

    if (this.cardPartDetail.state == '') {
      message += ' State';
    }

    if (this.cardPartDetail.address1 == '') {
      message += ' Address';
    }

    return message;
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public updateCenposDialog(cenposDialogVaue) {
    this.cenposDialog = cenposDialogVaue;
  }

  public async getPartSalesDetail(invoiceNumber): Promise<void> {
    try {
      this.partDetailLoader = true;
      // this.partSalesDetailLoading = true;
      const partSale = await partSalesService.getDetailAsync(invoiceNumber);
      this.partSaleDetail = partSale;
      this.fileOnCardsList = partSale.cards;
      if (
        this.partSaleDetail.partsSalesJson &&
        (!this.partSaleDetail.partsSalesJson.details ||
          !this.partSaleDetail.partsSalesJson.details.length)
      ) {
        this.partSaleDetail.partsSalesJson.details = [];
      }

      if (this.partSaleDetail.partsSalesJson.customerKey == '0') {
        this.partSaleDetail.partsSalesJson.customerKey = '';
      }
      if (this.partSaleDetail.customer == undefined) {
        this.partSaleDetail.customer = {
          name: '',
          email: '',
          email2: '',
          callTo: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zipCode: '',
          homePhone: '',
          cellPhone: '',
          businessPhone: '',
          customerKey: '',
        };
      }

      this.partSaleDetail.invoiceNumber = invoiceNumber;

      this.payment.paymentType = '';
      this.payment.amountPaid = '';
      this.payment.paymentType = PaymentTypeDialog.cardOnFile;
      this.paymentAmountDialog.model = true;
    } finally {
      // this.partSalesDetailLoading = false;
      // this.isLoaded = true;
      this.partDetailLoader = false;
    }
  }

  public async getPartSales(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const partSales = await partSalesService.getAllAsync(
        this.pagination,
        this.filter
      );
      this.partSales = partSales.results;
      this.pagination.totalItems = partSales.total;
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public getFilteredRecords() {
    this.pagination.page = 1;
    const queryStringObj = Object.assign({}, this.pagination) as any;
    queryStringObj.filters = this.filter.isOpenPartSaleOrder;
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getPartSales();
  }

  public async getShipToAddress(model: PartSale): Promise<void> {
    try {
      this.uberApproveDialog = true;
      this.shipAddressLoading = true;
      const resp = await partSalesService.getShipToAddressAsync(
        model.invoiceNumber
      );
      if (resp.status) {
        this.estimatedAmount = resp.estimatedPrice;
        this.uberRequestModel.estimatedPrice = resp.estimatedPrice;
        this.uberRequestModel.invoiceNumber = model.invoiceNumber;
        this.uberRequestModel.uberStoreId = resp.uberStoreId;
        this.uberRequestModel.placeId = resp.placeId;
        this.uberRequestModel.estimateId = resp.estimateId;
        this.uberRequestModel.shippingMethod = resp.shippingMethod;
        this.uberRequestModel.customerKey = resp.customerKey;
      } else {
        this.uberApproveDialog = false;
      }
    } catch (e) {
      this.uberApproveDialog = false;
      this.shipAddressLoading = false;
    } finally {
      this.shipAddressLoading = false;
    }
  }

  public async AddShippingOrder(): Promise<void> {
    try {
      this.isSubmitOrder = true;
      const resp = await partSalesService.addUberOrderAsync(
        this.uberRequestModel
      );
      if (resp.status) {
        this.showAlert(true, 'Request Approved Successfully');
      }
    } finally {
      this.uberApproveDialog = false;
      this.isSubmitOrder = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
    const queryStringObj = Object.assign({}, this.pagination) as any;
    if (queryStringObj) {
      queryStringObj.filters = this.filter.isOpenPartSaleOrder;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getPartSales();
  }

  public getQueryString(paging) {
    var data = [];
    for (var p in paging)
      if (paging.hasOwnProperty(p)) {
        data.push(encodeURIComponent(p) + '=' + encodeURIComponent(paging[p]));
      }
    return data.join('&');
  }

  public search(): void {
    this.pagination.page = 1;
    this.getPartSales();
  }

  // emit fuction
  public setDateValuesPartSales(date: any): void {
    this.filter.transDate = date;
  }

  public sumTotalAmount(): string {
    const shipping = isNaN(
      Number(this.partSaleDetail.partsSalesJson.shippingTotal)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.shippingTotal);
    const tax = isNaN(Number(this.partSaleDetail.partsSalesJson.taxTotal))
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.taxTotal);
    const specialOrderDeposit = isNaN(
      Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit)
    )
      ? 0
      : Number(this.partSaleDetail.partsSalesJson.specialOrderDeposit);
    const total =
      Number(this.partSaleDetail.partsSalesJson.partsTotal) +
      shipping +
      tax +
      specialOrderDeposit;
    return total.toFixed(2);
  }

  public paymentOptions: IPaymentDialog = {
    id: "PartSalePayment",
    url: window.location.href,
    amount: Number(this.cardPartDetail.amountPaid),
    totalAmount: this.cardPartDetail.amountPaid,
    customerEmail: this.cardPartDetail.email,
    recordIdentifier: "PartSale",
    customerKey: this.cardPartDetail.customerKey,
    type: "0",
    zipcode: this.cardPartDetail.zipCode,
    merchantEmail: this.cardPartDetail.email2,
    recordKey: this.cardPartDetail.invoiceNumber,
    isSendPaymentReceipt: this.isSendPaymentReceipt,
    isOverrideCCFeeApplied: this.isOverrideCCFeeApplied,
    bypassReason: this.bypassReason,
  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
